import {
  getUiBrand,
  MultiUiBrandProvider,
} from '@jarvis/react-setup-and-onboarding-addons'
import React, { PropsWithChildren, useMemo } from 'react'

export function UiBrandAppProvider({
  children,
}: Readonly<PropsWithChildren<unknown>>) {
  const uiBrand = useMemo(() => getUiBrand(), [])

  return (
    <MultiUiBrandProvider uiBrand={uiBrand}>{children}</MultiUiBrandProvider>
  )
}
